import { mapGetters } from "vuex";
import * as types from "@/store/types";
const Rial = () => import("@/components/OperationsPage/Withdrawal/Rial/index");
const Crypto = () =>
  import("@/components/OperationsPage/Withdrawal/Crypto/index");
import $carrySignFixed from "@/mixins/carrySignFixed";

export default {
  name: "withdrawal",
  components: { Rial, Crypto },
  props: [],
  mixins: [$carrySignFixed],
  data() {
    return {
      tab: 1,
      fromQueryIso: "",
      noFromQueryIso: ""
    };
  },
  computed: {
    ...mapGetters({
      QueryIsoGetter: types.operations.getters.GET_OPERATION_QUERY_ISO,
      getWithdrawCurrencies: types.operations.getters.GET_WITHDRAW_CURRENCIES,
      getUserInfo: types.userInfo.getters.GET_USER_INFO
    }),
    getQuery() {
      if (this.QueryIsoGetter) {
        return this.QueryIsoGetter;
      }
    },
    getFirstCurrencyFromWallet() {
      if (Object.entries(this.getWithdrawCurrencies).length !== 0) {
        return this.getWithdrawCurrencies[0];
      }
    },
    filteredRouteQueryTypes() {
      if (this.getUserInfo.is_global) {
        return this.$t("operationsPage.routeQueryTypes").filter(
          item => item.query !== "IRR"
        );
      }
      return this.$t("operationsPage.routeQueryTypes");
    }
  },
  mounted() {
    if (this.$route.query.from === "IRR") {
      this.tab = 0;
    }
  },
  watch: {
    getQuery: {
      immediate: true,
      handler(newValue) {
        this.fromQueryIso = newValue;
      }
    },
    getFirstCurrencyFromWallet: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.noFromQueryIso = newValue.currency.iso;
        }
      }
    }
  },
  methods: {
    addQueryParameters(dataQuery) {
      if (dataQuery === "IRR") {
        this.$router.push({ query: { from: dataQuery } });
      } else {
        if (this.fromQueryIso && this.fromQueryIso !== "IRR") {
          this.$router.push({ query: { from: this.fromQueryIso } });
        } else {
          this.$router.push({ query: { from: this.noFromQueryIso } });
        }
      }
    }
  }
};
